var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Pos } from './pos';
import { ItemGroup } from './item-group';
import { Period } from './period';
import { Store } from './store';
import { Category } from './category';
import { Data } from './data';
import { Item } from './item';
import { Setting } from './setting';
import { Badge } from './badge';
import { PriceRule } from './price-rule';
import { Discount } from './discount';
import { TaxRule } from "./tax-rule";
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.class = "Menu";
        _this.subs = [];
        _this.legacy = false;
        _this.itemOpenings = {};
        //current price level of this menu item.price
        _this.priceLevel = 1;
        return _this;
    }
    Menu.prototype.toProperty = function (name, value) {
        switch (name) {
            case "badges":
                value = Data.toDataArray(Badge, value);
                break;
            case "categories":
                value = Data.toDataArray(Category, value);
                break;
            case "subs":
                value = Data.toDataArray(Menu, value);
                break;
            case "groups":
                value = Data.toDataArray(ItemGroup, value);
                break;
            case "stores":
                value = Data.toDataArray(Store, value);
                break;
            case "periods":
                value = Data.toDataArray(Period, value);
                break;
            case "pos":
                value = Data.toData(Pos, value);
                break;
            case "recommendation":
                value = Data.toData(Category, value);
                break;
            case "unlocks":
                value = Data.toDataArray(Category, value);
                break;
            case "gifts":
                value = Data.toDataArray(Category, value);
                break;
            case "settings":
                value = Data.toData(Setting, value);
                break;
            case "items":
                value = Data.toDataArray(Item, value);
                break;
            case "priceRules":
                value = Data.toDataArray(PriceRule, value);
                break;
            case "create":
            case "update":
                value = new Date();
                break;
            case "taxRules":
                value = Data.toDataArray(TaxRule, value);
                break;
            case "discounts":
                value = Data.toDataArray(Discount, value);
                break;
            default:
                value = _super.prototype.toProperty.call(this, name, value);
                break;
        }
        return value;
    };
    return Menu;
}(Data));
export { Menu };
//# sourceMappingURL=menu.js.map